module.exports = __webpack_public_path__ + "static/media/aerputh.de04ab7c.jpeg";